import { useAPI } from '../../state';
export var CHANGE_USER_LANGUAGE_API = '/api/user/language/setting';
export var useChangeUserLanguage = function () {
  return useAPI(CHANGE_USER_LANGUAGE_API, {}, 'PUT');
};